var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal",
      attrs: {
        id: _vm.id,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "pricesModalTitle",
        "aria-hidden": "true",
        "data-keyboard": "false",
        "data-backdrop": "static"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg-96-percent",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("apps.inventory.label.selectserialnumber")) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: { click: _vm.onClose }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _vm.loading
                ? _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.loading")) +
                        "\n        "
                    )
                  ])
                : _c(
                    "div",
                    { staticStyle: { "overflow-x": "auto" } },
                    [
                      _c("base-table", {
                        attrs: {
                          tableClass: "table-border-none",
                          hidePagination: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "thead",
                            fn: function() {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", {
                                      staticStyle: { width: "40px" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      { staticStyle: { width: "160px" } },
                                      [_vm._v(_vm._s(_vm.$t("series.serial")))]
                                    ),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "apps.inventory.label.serialnumber"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("apps.inventory.label.product")
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "apps.inventory.label.warehouse"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("apps.inventory.label.bin")
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      { staticStyle: { width: "70px" } },
                                      [
                                        _c(
                                          "BaseSortLabel",
                                          {
                                            on: {
                                              onChange:
                                                _vm.handleChangeSortDateIn
                                            },
                                            model: {
                                              value: _vm.form.modelSort.dateIn,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form.modelSort,
                                                  "dateIn",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.modelSort.dateIn"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.label.datein"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      { staticStyle: { width: "70px" } },
                                      [
                                        _c(
                                          "BaseSortLabel",
                                          {
                                            on: {
                                              onChange:
                                                _vm.handleChangeSortDateProduct
                                            },
                                            model: {
                                              value:
                                                _vm.form.modelSort.dateProduct,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form.modelSort,
                                                  "dateProduct",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.modelSort.dateProduct"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.label.dateproduct"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      { staticStyle: { width: "70px" } },
                                      [
                                        _c(
                                          "BaseSortLabel",
                                          {
                                            on: {
                                              onChange:
                                                _vm.handleChangeSortDateExpire
                                            },
                                            model: {
                                              value:
                                                _vm.form.modelSort.dateExpire,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form.modelSort,
                                                  "dateExpire",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.modelSort.dateExpire"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.label.dateexpire"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      [
                                        _c(
                                          "BaseSortLabel",
                                          {
                                            on: {
                                              onChange:
                                                _vm.handleChangeSortUnitBalance
                                            },
                                            model: {
                                              value:
                                                _vm.form.modelSort.unitBalance,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form.modelSort,
                                                  "unitBalance",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.modelSort.unitBalance"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.label.unit"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      [
                                        _c(
                                          "BaseSortLabel",
                                          {
                                            on: {
                                              onChange: _vm.handleChangeSortCost
                                            },
                                            model: {
                                              value: _vm.form.modelSort.cost,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form.modelSort,
                                                  "cost",
                                                  $$v
                                                )
                                              },
                                              expression: "form.modelSort.cost"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.label.cost"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      { staticStyle: { width: "130px" } },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "apps.inventory.label.pick"
                                              )
                                            ) +
                                            "\n                    (" +
                                            _vm._s(_vm.pickedCount) +
                                            ")\n                  "
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "tbody",
                            fn: function() {
                              return [
                                _c(
                                  "tbody",
                                  [
                                    !_vm.form.modelSerials.length
                                      ? _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass: "text-center",
                                              attrs: { colspan: "11" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.notfounddata"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(_vm.form.modelSerials, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "tr",
                                        {
                                          key: index,
                                          staticStyle: { height: "44px" }
                                        },
                                        [
                                          _c(
                                            "td",
                                            [
                                              _c("BaseCheckbox", {
                                                attrs: { val: true },
                                                model: {
                                                  value: item.checked,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "checked",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.checked"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            [
                                              _c(
                                                "vs-tooltip",
                                                {
                                                  staticStyle: {
                                                    float: "left",
                                                    margin: "0px 5px 0 0"
                                                  },
                                                  attrs: {
                                                    text: item.isReady
                                                      ? _vm.$t(
                                                          "apps.inventory.message.serialready"
                                                        )
                                                      : _vm.$t(
                                                          "apps.inventory.message.serialnotready"
                                                        ),
                                                    position: "top"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    class: [
                                                      "fas fa-circle",
                                                      item.isReady
                                                        ? "text-success"
                                                        : "text-warning"
                                                    ],
                                                    staticStyle: {
                                                      "font-size": "9px",
                                                      position: "relative",
                                                      top: "-2px"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(item.serCode) +
                                                  "\n                  "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(item.serialNumber) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-secondary"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.getProductFullName(
                                                        item.product
                                                          .productName,
                                                        item.sku.attributes
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  item.warehouse.warehouseName
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  item.warehouse.binLocations.reduce(
                                                    function(acc, cur) {
                                                      if (
                                                        cur.id ===
                                                        item.binLocationId
                                                      ) {
                                                        acc = cur.code
                                                      }
                                                      return acc
                                                    },
                                                    null
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  item.dateIn
                                                    ? _vm.getDate(item.dateIn)
                                                    : null
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  item.dateProduct
                                                    ? _vm.getDate(
                                                        item.dateProduct
                                                      )
                                                    : null
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  item.dateExpire
                                                    ? _vm.getDate(
                                                        item.dateExpire
                                                      )
                                                    : null
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(item.unitBalance) +
                                                "/" +
                                                _vm._s(item.unitInit) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.getNumber(item.cost)
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            [
                                              item.checked
                                                ? _c("BaseInputNumber", {
                                                    attrs: { disabled: true },
                                                    model: {
                                                      value: item.unit,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "unit",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.unit"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      })
                    ],
                    1
                  )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-light",
                  attrs: { type: "button" },
                  on: { click: _vm.onCancel }
                },
                [_vm._v(_vm._s(_vm.$t("button.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-web",
                  attrs: {
                    disabled: _vm.loading || !_vm.form.modelSerials.length,
                    type: "button"
                  },
                  on: { click: _vm.onSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("button.apply")))]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f1ce5d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f1ce5d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseSelectSerialNumberModal.vue
// module id = null
// module chunks = 